import load_maps from '../app/map';
import 'imagesloaded/imagesloaded';
import Slider from '../app/slider';

export default {
  init() {
        $(window).on('load', () => {
            load_maps();
      });

      jQuery('section.timeline').imagesLoaded(() => {
          new Slider('section.timeline', {
              loop: false,
              margin: 0,
              nav: true,
              items: 1,
              dots: false,
              autoplay: true,
              responsiveClass: true,
              navText: ['<i class="im im-chevron-left"></i>', '<i class="im im-chevron-right"></i>'],
              responsive: {
                  // breakpoint from 768 up
                  1300: {
                      items: 2,
                  },
              },
          });
      });

      ////////////////////////////////////////////////////////////////////////////////////////////
      // Add Class for mobile menu
      ////////////////////////////////////////////////////////////////////////////////////////////

      jQuery('div.mobile-menu').click(function(){
          jQuery('nav.nav-primary').toggleClass('active');
      });

      jQuery('div.mobile-menu').click(function(){
          jQuery('div.mobile-menu').toggleClass('open');
      });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js